import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { ProdStaticPath } from '@flipster/utils/url';

const MultiAssetsCollateral = () => {
  return (
    <div className={flex({ flex: 1, direction: 'column', gap: 16 })}>
      <h2 className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Multi_assets_collateral' />
      </h2>
      <div
        className={flex({
          justify: 'center',
          align: 'center',
          bg: 'background.default.level-1',
          rounded: 8,
        })}
      >
        <img
          src={`${ProdStaticPath}/images/web/collateral_overview_02.png`}
          alt='multi-assets-collateral'
          width={328}
          height={190}
        />
      </div>
      <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Multi_assets_collateral_lets_you_combine_different_assets_in_your_account_and_use_them_together_as_margin' />
      </p>
    </div>
  );
};

export default MultiAssetsCollateral;
